var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row bg-white shadow py-5 px-3 mb-4" }, [
      _c("div", { staticClass: "col-12" }, [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-1 text-left" }, [
            _c("b", [_vm._v("Selec.")])
          ]),
          _c("div", { staticClass: "col-1" }, [_c("b", [_vm._v("Folio")])]),
          _c("div", { staticClass: "col-2" }, [_c("b", [_vm._v("Flujo")])]),
          _c("div", { staticClass: "col-2" }, [
            _c("b", [_vm._v("Estado general")])
          ]),
          _c("div", { staticClass: "col-2" }, [
            _c("b", [_vm._v("Estado paso")])
          ]),
          _c("div", { staticClass: "col-2" }, [
            _c("b", [_vm._v("Fecha inicio")])
          ]),
          _c("div", { staticClass: "col-2" }, [_c("b", [_vm._v("Documento")])])
        ])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }